import { render, staticRenderFns } from "./ClientsVerticalMenu.vue?vue&type=template&id=61be6114&scoped=true"
import script from "./ClientsVerticalMenu.vue?vue&type=script&lang=js"
export * from "./ClientsVerticalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be6114",
  null
  
)

export default component.exports